import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateCategoryLookupComponent } from './template-category-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TemplateCategoryLookupComponent],
  exports: [TemplateCategoryLookupComponent]
})
export class TemplateCategoryLookupModule { }
